import ModalForm from "./Form";
import { SALES_PAYMENT, DATATABLE_EXPORT } from "../../../../Config/ApiUrl";

export const Schema = {
	components: { ModalForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "SALES-PAYMENT-table",
			rowData: {},
			formId: "SALES-PAYMENT-form",
			tableColumns: [
				{
					title: "Invoice",
					type: "custom-html",
					key: "invoice_fk",
					isVisible: true,
					modifier: (value) => {
						return value ? value.invoice_no : '-'
					},
				},
				{
					title: "Bank Account",
					type: "custom-html",
					key: "bank_account_id",
					isVisible: true,
					modifier: (value) => {
						return value ? value.bank_account_name + ' - ' + value.bank_account_virtual_no : '-'
					},
				},
				{
					title: "Received Date",
					type: "text",
					key: "received_date",
				},
				{
					title: "Received Value",
					type: "custom-html",
					key: "received_value",
					isVisible: true,
					modifier: (value) => {
						return this.formattedIDR(value) ? this.formattedIDR(value) : this.formattedIDR(0);
					},
				},
				{
					title: "Refund",
					type: "custom-html",
					key: "is_refund",
					isVisible: true,
					modifier: (value) => {
						return value == 0 ? 'No' : 'Yes';
					}
				},
			],
			ENDPOINT: SALES_PAYMENT,
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "SALES_PAYMENT",
				url: SALES_PAYMENT,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "SALES-PAYMENT-form",
						modifier: () => this.$can('view_list_salespayment_button_modalupdateinfo')
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
						modifier: () => this.$can('view_list_salespayment_button_delete')
					},
				],
				filters: [
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
	},
};
